import { Lock, ArrowLeft, ArrowUpCircle, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

interface AccessDeniedPageProps {
  featureName?: string;
}

const FEATURE_NAMES: Record<string, string> = {
  crm: "CRM",
  financeiro: "Financeiro",
  instalacoes: "Instalações",
  whatsapp: "WhatsApp",
  whatsapp_hub: "WhatsApp Hub",
  whatsapp_meta: "WhatsApp Meta API",
  whatsapp_campaigns: "Campanhas WhatsApp",
  prospeccao_bdr: "Prospecção BDR",
  agentes_ia: "Agentes IA",
  agente_sdr: "Agente SDR",
  auto_deal_creation: "Criação Automática de Oportunidade",
  suprimentos: "Suprimentos",
  atividades: "Atividades",
  logistica: "Logística",
  portal_cliente: "Portal do Cliente",
  ai_insights: "IA & Insights",
  relatorios: "Relatórios Avançados",
  api_access: "API & Webhooks",
  white_label: "White Label",
  sales_page: "Página de Vendas",
  auto_proposta: "Auto Proposta",
  contratos: "Contratos & Assinatura Digital",
  dimensionamento: "Dimensionamento Solar",
  conciliacao_bancaria: "Conciliação Bancária",
  comissoes: "Comissões Automáticas",
  importacao_csv: "Importação CSV",
  dre: "DRE Gerencial",
  multi_pipeline: "Múltiplos Pipelines",
};

export default function AccessDeniedPage({ featureName }: AccessDeniedPageProps) {
  const navigate = useNavigate();
  const label = featureName ? FEATURE_NAMES[featureName] || featureName : "este módulo";

  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
            <Lock className="h-8 w-8 text-amber-600 dark:text-amber-400" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold tracking-tight text-foreground">
            Funcionalidade exclusiva de planos superiores
          </h1>
          <p className="text-muted-foreground">
            O módulo <strong>{label}</strong> está disponível em planos superiores.
            Faça upgrade para desbloquear todo o potencial da plataforma.
          </p>
        </div>

        <Card className="border-border/50 bg-muted/30">
          <CardContent className="py-5 space-y-2.5 text-left text-sm">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Check className="h-4 w-4 text-primary shrink-0" />
              Acesso completo ao módulo
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Check className="h-4 w-4 text-primary shrink-0" />
              Sem limite de uso
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Check className="h-4 w-4 text-primary shrink-0" />
              Suporte prioritário
            </div>
          </CardContent>
        </Card>

        <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Button onClick={() => navigate("/app/minha-conta")} className="gap-2">
            <ArrowUpCircle className="h-4 w-4" />
            Ver planos e fazer upgrade
          </Button>
          <Button variant="outline" onClick={() => navigate(-1)} className="gap-2">
            <ArrowLeft className="h-4 w-4" />
            Voltar
          </Button>
        </div>
      </div>
    </div>
  );
}
